/**
 * Returns Tailwind CSS classes for a subscription tier badge.
 * Keys must match the CatalogKey / MinimalSubscriptionKey values from the API (case-insensitive).
 */
export interface PlanBadgeStyle {
  container: string;
  icon: string;
}

const PLAN_BADGE_STYLES: Record<string, PlanBadgeStyle> = {
  free:       { container: 'badge-plan-free border',       icon: 'icon-off' },
  basic:      { container: 'badge-plan-basic border',      icon: 'text-status-active' },
  pro:        { container: 'badge-plan-pro border',        icon: 'icon-on' },
  enterprise: { container: 'badge-plan-enterprise border', icon: 'text-status-warning' },
};

const FALLBACK_STYLE: PlanBadgeStyle = {
  container: 'badge-plan-free border',
  icon:      'icon-off',
};

export function getPlanBadgeStyle(tierKey: string | null | undefined): PlanBadgeStyle {
  if (!tierKey) return FALLBACK_STYLE;
  return PLAN_BADGE_STYLES[tierKey.toLowerCase()] ?? FALLBACK_STYLE;
}
